import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/custom.scss';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { loadConfig } from './config';
import { setEnvironment } from './environments';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

loadConfig().then(config => {
  setEnvironment(config.ENVIRONMENT);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

reportWebVitals(); 